import Handlebars from 'handlebars';
import api from './api';

const table = {
    manifest: null,
    template: null,
    page: 1,
    offset: 0,
    limit: 10,
    sort: typeof stateKey == 'undefined' ? 'state_s' : stateKey,
    order: 'asc',
    stateData: [],
    tableEl: null,
    end: false,

    // initialize drawing table by getting maniefest data, in callback retrieve state data, and then format data for table
    init: function(){
        api.getManifest().then(res => {
            this.manifest = res.body;
            this.getStateData("initialize");
        });
        this.tableEl = document.getElementById('table');
    },

    getStateData: function(option, callbackFn = (()=>{})){
        api.getStateData({fields: 'dcwsi_ind_i,wsp_ind_i,dcwe_ind_i', limit: this.limit, page: this.page, offset: this.offset, sortBy: this.sort, order: this.order}).then(res => {
            //clicking header row will replace data ordered by column
            if(option == 'replace'){
                this.stateData = res.body.data;
            } else {
                // clicking pagination will append fecthed data
                this.stateData = [...this.stateData, ...res.body.data];
            }
            // initial setup and listeners
            if(option == 'initialize'){
                this.page = this.page + 1;
                this.tableEl.innerHTML = this.renderTable();
                this.attachClickListener();
            } else {
                // we're reached end
                if(!(this.stateData.length < res.body.meta.count)){
                    this.end = true;
                }
                callbackFn();
            }
        });
    },

    attachClickListener: function(){
        document.body.addEventListener('click', (e) => {
            let el = e.target;
            if(el.classList.contains('.load-next') || el.closest('.load-next')){
                let btn = el.classList.contains('.load-next') ? el : el.closest('.load-next');
                this.loadStatesClickHandler(btn);
            }
            if(el.classList.contains('.sort-table') || el.closest('.sort-table')){
                let btn = el.classList.contains('.sort-table') ? el : el.closest('.sort-table');
                this.tableHeadingClickHandler(btn);
            }
            if(el.classList.contains('.state-dropdown-trigger') || el.closest('.state-dropdown-trigger')){
                let btn = el.classList.contains('.state-dropdown-trigger') ? el : el.closest('.state-dropdown-trigger');
                let btnWrapper = btn.closest('.mobile-wrapper');
                let stateInfo = btnWrapper.querySelector('.state-dropdown');
                btnWrapper.classList.toggle('open');
                document.querySelectorAll('.mobile-wrapper.open').forEach((wrapper) => {
                    if(btnWrapper !== wrapper){
                        wrapper.classList.remove('open');
                    }
                });
                stateInfo.style.maxHeight = `${stateInfo.scrollHeight}px`;
            }
        });
    },

    //sort by header value
    tableHeadingClickHandler: function(btn){
        this.order = (this.order == 'asc' && this.sort == btn.dataset.sort) ? 'desc' : 'asc';
        this.sort = btn.dataset.sort;
        let initialPage = this.page;
        let initialLimit = this.limit;
        this.limit = this.stateData.length;
        this.page = 1;
        this.getStateData('replace', () => {
            this.page = initialPage;
            this.limit = initialLimit;
            let tableHtml = this.renderTable();
            this.tableEl.innerHTML = tableHtml;
        });
    },

    //get next set of states
    loadStatesClickHandler: function(btn){
        if(!this.end){
            this.getStateData('append', () => {
                this.page = this.page + 1;
                let tableHtml = this.renderTable();
                this.tableEl.innerHTML = tableHtml;
            });
        } else {
            let opacity = parseFloat(window.getComputedStyle(btn).getPropertyValue('opacity'));
            btn.style.opacity = opacity * 0.666;
        }
    },

    //combine manieft and state to table rendered in handlebars
    renderTable: function(){
        if(!this.template){
            this.template = document.getElementById('statesTable').innerHTML;
        }
        let table = Handlebars.compile(this.template);
        let tableData = {states: []};
        let rankKey = Object.keys(this.manifest)[0];
        tableData.heading = this.manifest[rankKey].name + ' Rankings';
        let children = this.manifest[rankKey].children;
        tableData.columns = [
            {label: 'Rank', sort: rankKey, order: this.sort == rankKey ? this.order : null},
            {label: 'State', sort: stateKey, order:  this.sort == stateKey ? this.order : null},
        ];
        for(var key in children){
            tableData.columns.push({label: children[key].name, sort: key, suffix: (this.manifest[rankKey].unit_position == 'After' ? this.manifest[rankKey].unit : ''), order: this.sort == key ? this.order : null});
        }
        this.stateData.forEach((state) => {
            let stateObj = {};
            tableData.columns.forEach((column) => {
                stateObj[column.sort] = state[column.sort];
                stateObj.order = [column.order];

            });
            stateObj[stateKey] = {url: state.url, title: state.name};
            tableData.states.push(stateObj);
        });
        tableData.query = {
            page: this.page,
            offset: this.offset,
            limit: this.limit,
            sort: this.sort,
            order: this.order
        };

        return table(tableData);
    },
}

export default table;
